/* PRISKEL · Build your own stack, range switch for the builder and the curated stacks. Works alongside pk-byos.js. */
(function () {
  function swap(el) { if (!el) return; el.classList.remove('is-swap'); void el.offsetWidth; el.classList.add('is-swap'); }

  function setRange(root, v) {
    var grid = root.querySelector('[data-pk-by-grid]');
    root.querySelectorAll('[data-pk-byx-range]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-pk-byx-range') === v ? 'true' : 'false'); });
    var types = {};
    grid.querySelectorAll('[data-pk-by-item]').forEach(function (it) {
      var on = v === '*' || it.getAttribute('data-range') === v;
      it.classList.toggle('is-xr', !on);
      if (on) types[it.getAttribute('data-type')] = 1;
    });
    /* back to every category, and only offer categories that exist in this range */
    var all = root.querySelector('[data-pk-by-filter="*"]');
    if (all && all.getAttribute('aria-pressed') !== 'true') all.click();
    root.querySelectorAll('[data-pk-by-filter]').forEach(function (c) {
      var t = c.getAttribute('data-pk-by-filter');
      c.classList.toggle('is-xr', t !== '*' && !types[t]);
    });
    var row = root.querySelector('.pk-by__chips');
    if (row) row.classList.toggle('is-xr', Object.keys(types).length < 2);
    swap(grid);
  }

  function init(root) {
    if (root.__pkx) return; root.__pkx = 1;
    reveal(root);
    /* panel state: hide the zero totals until there is something to total */
    var panel = root.querySelector('[data-pk-by-panel]'), slots = root.querySelector('[data-pk-by-slots]'), addB = root.querySelector('[data-pk-by-add]');
    function state() {
      if (!panel) return;
      panel.classList.toggle('is-empty', !root.querySelector('.pk-by__slot.is-full'));
      var ready = addB && !addB.disabled;
      if (ready && !panel.classList.contains('is-ready')) { panel.classList.add('is-ready'); }
      else if (!ready) panel.classList.remove('is-ready');
    }
    if (slots && 'MutationObserver' in window) new MutationObserver(state).observe(slots, { attributes: true, subtree: true, attributeFilter: ['class'] });
    if (addB && 'MutationObserver' in window) new MutationObserver(state).observe(addB, { attributes: true, attributeFilter: ['disabled'] });
    state();
    deep(root);
    root.addEventListener('click', function (e) {
      var pk = e.target.closest('[data-pk-by-pick]');
      if (pk && pk.getAttribute('aria-pressed') === 'true') { var it = pk.closest('[data-pk-by-item]'); setTimeout(function () { fly(root, it); }, 20); }
    });
    root.addEventListener('click', function (e) {
      var j = e.target.closest('[data-pk-byx-jump]');
      if (j) { var btn = root.querySelector('[data-pk-byx-range="' + j.getAttribute('data-pk-byx-jump') + '"]'); if (btn) setRange(root, j.getAttribute('data-pk-byx-jump')); return; }
      var r = e.target.closest('[data-pk-byx-range]');
      if (r) { setRange(root, r.getAttribute('data-pk-byx-range')); return; }
      var c = e.target.closest('[data-pk-byx-c]');
      if (c) {
        var v = c.getAttribute('data-pk-byx-c');
        root.querySelectorAll('[data-pk-byx-c]').forEach(function (b) { b.setAttribute('aria-pressed', b === c ? 'true' : 'false'); });
        root.querySelectorAll('[data-pk-byx-cr]').forEach(function (card) { card.hidden = v !== '*' && card.getAttribute('data-pk-byx-cr') !== v; });
        swap(root.querySelector('.pk-by__cards'));
        return;
      }
      /* "Edit in builder" shows every range so the chosen pieces are visible */
      if (e.target.closest('[data-pk-by-edit]') && root.querySelector('[data-pk-byx-range]')) {
        root.querySelectorAll('[data-pk-by-item].is-xr').forEach(function (it) { it.classList.remove('is-xr'); });
        root.querySelectorAll('[data-pk-by-filter].is-xr, .pk-by__chips.is-xr').forEach(function (it) { it.classList.remove('is-xr'); });
        root.querySelectorAll('[data-pk-byx-range]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-pk-byx-range') === '*' ? 'true' : 'false'); });
      }
    });
  }

  /* ?range=utsav|everyday|black opens the builder and the curated stacks on that range */
  function deep(root) {
    var m = location.search.match(/[?&]range=([^&#]+)/); if (!m) return;
    var k = { utsav: 'ut', ut: 'ut', everyday: 'ev', ev: 'ev', black: 'men', men: 'men' }[decodeURIComponent(m[1]).toLowerCase()];
    if (!k) return;
    var bk = { ev: 'collection', ut: 'collection_ut', men: 'collection_men' }[k];
    if (root.querySelector('[data-pk-byx-range="' + bk + '"]')) setRange(root, bk);
    var c = root.querySelector('[data-pk-byx-c="' + k + '"]');
    if (c) {
      root.querySelectorAll('[data-pk-byx-c]').forEach(function (b) { b.setAttribute('aria-pressed', b === c ? 'true' : 'false'); });
      root.querySelectorAll('[data-pk-byx-cr]').forEach(function (card) { card.hidden = card.getAttribute('data-pk-byx-cr') !== k; });
    }
    var t = location.hash && root.querySelector(location.hash);
    if (t) setTimeout(function () {
      var h = document.querySelector('header, .hdt-header, [data-header]'), off = h ? Math.min(h.getBoundingClientRect().height, 120) : 0;
      window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - off - 8, behavior: 'auto' });
    }, 120);
  }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function inView(r) { return r.width > 0 && r.bottom > 0 && r.top < window.innerHeight; }
  /* the picked piece floats into its slot (panel on laptop, bottom bar on phone) */
  function fly(root, item) {
    if (reduce) return;
    var src = item.querySelector('.pk-by-it__img img.is-a') || item.querySelector('.pk-by-it__img img');
    if (!src) return;
    var full = root.querySelectorAll('.pk-by__slot.is-full .pk-by__slot-im');
    var tgt = full.length ? full[full.length - 1] : null;
    if (!tgt || !inView(tgt.getBoundingClientRect())) {
      var bs = root.querySelectorAll('.pk-by__bar.is-on .pk-by__bar-slots i');
      tgt = null;
      for (var i = bs.length - 1; i >= 0; i--) { if (bs[i].querySelector('img')) { tgt = bs[i]; break; } }
    }
    if (!tgt) return;
    var a = src.getBoundingClientRect(), b = tgt.getBoundingClientRect();
    if (!inView(a) || !inView(b)) return;
    var c = document.createElement('img');
    c.id = 'pk-byx-fly'; c.src = src.currentSrc || src.src; c.alt = '';
    c.style.left = a.left + 'px'; c.style.top = a.top + 'px'; c.style.width = a.width + 'px'; c.style.height = a.height + 'px';
    document.body.appendChild(c);
    var dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    var s = Math.max(b.width / a.width, .08);
    var anim = c.animate([
      { transform: 'translate(0,0) scale(1)', opacity: .95, borderRadius: '14px' },
      { transform: 'translate(' + dx * .55 + 'px,' + (dy * .55 - 40) + 'px) scale(' + (s + (1 - s) * .45) + ')', opacity: .9, offset: .55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + s + ')', opacity: .2, borderRadius: '999px' }
    ], { duration: 720, easing: 'cubic-bezier(.22,.61,.36,1)' });
    anim.onfinish = function () { c.remove(); };
    setTimeout(function () { if (c.parentNode) c.remove(); }, 900);
  }

  function reveal(root) {
    var items = [].slice.call(root.querySelectorAll('[data-pk-by-item]'));
    if (reduce || !('IntersectionObserver' in window)) return;
    items.forEach(function (it) { if (it.getBoundingClientRect().top > window.innerHeight) it.classList.add('pk-byx-rv'); });
    var io = new IntersectionObserver(function (en) {
      var n = 0;
      en.forEach(function (e) { if (e.isIntersecting) { e.target.style.setProperty('--d', (n++ * .06) + 's'); e.target.classList.add('is-seen'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (it) { if (it.classList.contains('pk-byx-rv')) io.observe(it); });
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-pk-by]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 60); });
})();
